<template>
    <div class="all">
        <div class="screen">
            <div class="item clearfix">
                <div class="corm clearfix fl">
                    <span class="element cp" :class="{curr:conditionsIndex === index}" v-for="(item,index) in conditions.list" @click="selectCondition(index,item.conditionId);" :key="index">
                        {{item.conditionName}}
                        <a href="javascript:void(0);" title="删除" class="cha color-red" @click.stop="delConditions(item.conditionId,index)">×</a>
                    </span>
                </div>
                <div class="fr">
                    <div class="search-warp clearfix">
                        <span class="drop-down fl">
                            <button class="btn search-dropdown"><input class="text resetValue" :value="searchText[searchSelectVal]"><i class="icons"></i></button>
                            <ul class="option">
                                <li v-for="(item,index) in searchText" @click="searchSelect(index);" :key="index">{{item}}</li>
                            </ul>
                        </span>
                        <button class="search-btn fr" @click="KeyUpEsc"><i class="icons search-icon"></i></button> 
                        <div class="hidden"><input type="text" v-model.trim="keywords" @keyup.enter="KeyUpEsc" :placeholder="searchPlaceholder[searchSelectVal - 1]" class="input-text"></div>
                    </div>
                </div>
            </div>
            <div class="item clearfix">
                <span class="zu clearfix">
                    <span class="name">时间范围</span>
                    <div class="clearfix fl">
                        <div class="corm fl">
                            <a class="element" :class="{curr:timeType===5}" href="javascript:void(0)" @click="selectFixedTime(5);">24小时</a>
                            <a class="element" :class="{curr:timeType===0}" href="javascript:void(0)" @click="selectFixedTime(0);">今天</a>
                            <a class="element" :class="{curr:timeType===1}" href="javascript:void(0)" @click="selectFixedTime(1);">昨天</a>
                            <a class="element" :class="{curr:timeType===2}" href="javascript:void(0)" @click="selectFixedTime(2);">近三天</a>
                            <a class="element" :class="{curr:timeType===3}" href="javascript:void(0)" @click="selectFixedTime(3);">近七天</a>
                            <a class="element" :class="{curr:timeType===4 || timeType===6}" href="javascript:void(0)" @click="selectFixedTime(4);">自定义</a>
                        </div>
                        <vue-datepicker-local v-if="timeType === 4 || timeType===6" class="fl" v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" show-buttons :disabledDate="disabledDate"  @confirm="selectedDate"/>
                    </div>
                </span>
            </div>
            <div class="item mt10 clearfix">
                <span class="name">媒体类型</span>
                <div class="screen-list">
                    <label class="checkbox-box" v-for="(item,index) in MediaPlatformList" :key="index">
                        <label class="checkbox-warp fl" :class="platformType.indexOf(index) != -1 ? 'curr' : ''">
                            <input class="checkbox" v-model="platformType" name="" type="checkbox" :value="index">
                            <i class="icons checkbox-icon"></i>
                        </label>
                        {{item.name}} <span class="color-8a8a99">({{item.num}})</span>
                    </label>
                </div>
            </div>
			<!-- 隐藏开始 -->
			<div class="condition-box clearfix" :class="openHide ? 'kai' : ''">
				<div class="item mt10 clearfix">
				    <span class="name">情感属性</span>
				    <div class="screen-list">
				        <label class="checkbox-box" v-for="(item,index) in emotionList" :key="index">
				            <label class="checkbox-warp fl" :class="emotion.indexOf(item) != -1 ? 'curr' : ''">
				                <input class="checkbox" v-model="emotion" name="" type="checkbox" :value="item">
				                <i class="icons checkbox-icon"></i>
				            </label>
							{{item}}
				        </label>
				    </div>
				</div>
                
                <div class="item clearfix">
				    <span class="d-flex">
				        <span class="name">媒体类别</span>
                        <platTypeCascader title="媒体类别" :industryTypeList="mediaLevelList" :morenzhi="morenzhi" @putData="getPlanvalue"></platTypeCascader>
				    </span>
                </div>
				<div class="item clearfix">
				    <span class="zu clearfix">
				        <span class="name">精准筛选</span>
				        <span class="drop-down">
				            <button class="btn btn-lightblue"><span class="texts">{{mateList[searchMode - 1]}}</span><i class="icons"></i></button>
				            <ul class="option">
				                <li v-for="(item,index) in mateList" @click="searchModeSelect(index+1)" :key="index">{{item}}</li>
				            </ul>
				        </span>
				    </span>
				    <span class="zu clearfix">
				        <span class="name">定向信源</span>
				        <span class="drop-down">
				            <button class="btn btn-lightblue"><span class="texts">{{xinYuanList[source]}}</span><i class="icons"></i></button>
				            <ul class="option">
				                <li v-for="(item,index) in xinYuanList" @click="xinYuanSelect(index)" :key="index">{{item}}</li>
				            </ul>
				        </span>
				    </span>
				    <span class="zu clearfix">
				        <span class="name">发布地区</span>
				        <city ref="cityWarp" @cityCallback="citySelect"></city>
				    </span>
					<span class="zu clearfix">
					    <span class="name">匹配模式</span>
					    <span class="drop-down">
					        <button class="btn btn-lightblue"><span class="texts">{{pipei[match - 1]}}</span><i class="icons"></i></button>
					        <ul class="option">
					            <li v-for="(item,index) in pipei" :key="index" @click="dropDownSelect(2,index+1)">{{item}}</li>
					        </ul>
					    </span>
					</span>
				</div>
				<div class="item clearfix">
				    <span class="zu clearfix">
				        <span class="name">排序方式</span>
				        <span class="drop-down">
				            <button class="btn btn-lightblue"><span class="texts">{{paixu[sort]}}</span><i class="icons"></i></button>
				            <ul class="option">
				                <li v-for="(item,index) in paixu" :key="index"  @click="dropDownSelect(3,index)">{{item}}</li>
				            </ul>
				        </span>
				    </span>
				    <span class="zu clearfix">
				        <span class="name">重复信息</span>
				        <span class="drop-down">
				            <button class="btn btn-lightblue"><span class="texts">{{repeatList[collapse]}}</span><i class="icons"></i></button>
				            <ul class="option">
				                <li v-for="(item,index) in repeatList" @click="selectRepeat(index)" :key="index">{{item}}</li>
				            </ul>
				        </span>
				    </span>
                    <span class="zu clearfix">
				        <span class="name">是否原发</span>
				        <span class="drop-down">
				            <button class="btn btn-lightblue"><span class="texts">{{originList[origin]}}</span><i class="icons"></i></button>
				            <ul class="option">
				                <li v-for="(item,index) in originList" @click="selectOriginlist(index)" :key="index">{{item}}</li>
				            </ul>
				        </span>
				    </span>
				</div>
			</div>
			<div class="mt10">
				<a class="open-retract color-blue" href="javascript:void(0);" @click="openHide = !openHide">{{openHide ? '收起' : '展开'}}<i class="icons" :class="openHide ? 'arrow-bottom' : 'arrow-top'"></i></a>
			</div>
			<!-- 隐藏结束 -->
			<div class="item mt20 clearfix ar">
				<button class="btn btn-border-blue" @click="resetConditions">重&nbsp;&nbsp;置</button>
			    <button class="btn btn-blue" @click="openSaveConditions">保&nbsp;&nbsp;存</button>
			</div>
        </div>
        <div class="warp mt20">
            <div class="warp-header">
                <div class="firle clearfix">
                    <div class="fl">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl" :class="uuids.length === pageUuid.length &&  uuids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll" :checked="uuids.length === pageUuid.length && uuids.length > 0 ? true : false"  @click="checkAll($event)" type="checkbox" value="0">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <span class="checkbox-box cp tion" @click="earlyWarning();">预警</span>
                        <!-- <span class="checkbox-box tion">删除</span> -->
                        <span class="checkbox-box cp tion" @click="downLoad(1);" title="下载当前所选数据">批量下载</span>
                        <span class="checkbox-box cp tion" @click="downLoad(2);" title="下载当前方案的所有数据">全部下载</span>
                        <span class="checkbox-box cp tion" @click="deleteList('all');" title="">删除</span>
                    </div>
                </div>
            </div>
            <!-- 定时查看数据 -->
            <div class="blue-block ac" v-if="noUpdateNum > 0"><a class="color-blue" href="javascript:void(0);" @click="updateCurrentData();">{{noUpdateNum}}条新消息，点击查看</a></div>
            <div class="warp-body clearfix">
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <ul class="article-list mtfu24">
                    <li v-for="(item,index) in newsList" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="uuids.indexOf(item.newsId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="uuids" name="chooseInfo" type="checkbox" :value="item.newsId">
                                <i class="icons checkbox-icon"></i>
                            </label>     
                        </div> 
                        <div class="article-right fr">
                            <div class="article-btn">
                                <span class="collect" @click="collectFn(index);" :class="item.collectStatus === 0 ? '' : 'curr'"><i class="icons collect-icon"></i></span>
                                <!-- <span class="sign sign-blue">改</span> -->
                                <span class="sign sign-orange cp" :class="item.warningStatus === 0 ? '' : 'gray'" @click="earlyWarning(item.warningStatus,item.newsId);">警</span>
                                <span class="sign sign-red cp" @click="errorCorrection(item.newsId);">纠</span>
                                <span class="sign sign-red cp" @click="deleteList(item.newsId);">删</span>
                                <span class="sign sign-blue cp" @click="oneClickCopy(index)">复</span>
                                <span class="sign sign-blue cp" @click="newsPathlist(item.newsSimHash)">溯</span>
                                <!-- <span class="sign sign-red">删</span> -->
                            </div>  
                        </div> 
                        <div class="article-mid">
                            <h2 class="article-title clearfix">
								<div class="title ovhidden fl" :class="{difference:item.platform === 'comment'}">
									<span class="tag" :class="$parent.attributeType[item.newsEmotion]" @mouseover="showMaskmove(index)" @mouseleave="showMaskmove(index)">{{item.newsEmotion}}</span>
									<router-link class="color-3d3d4c" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate+','+match}}" v-html="item.newsTitle" :title="item.newsTitle"></router-link>
								</div>
								<div class="fu fl" v-if="item.platform === 'comment'">
									<span class="color-red fs12">评</span>
								</div>
							</h2>
							<p class="ovhidden2 color-8a8a99" :title="item.newsDigest" v-html="item.newsDigest"></p>
                            <p class="ziduan color-8a8a99 mt10">
                                <span><a class="color-8a8a99" target="_blank" :href="item.newsUrl">时间：{{item.newsPosttime}}</a></span>
                                <span>相似文章：<a class="color-blue" :class="item.simNum === '' ? 'load-sm' : ''" href="javascript:void(0);" @click="jumpSimilar(item.newsId);">{{item.simNum}}</a></span></span>
                                <span>发布平台：<i class="icons sm-icon" :class="icons[item.platform]"></i>{{item.platformName}}</span>
                                <span>发布人：{{item.mediaName}}</span>
                                <span v-if="item.mediaProvince != ''">发布地区：{{item.mediaProvince}}</span>
                                <span  v-if="item.keywords != ''">分析词：<i :class="item.keywords == '' ? 'load-sm' : ''"></i>{{item.keywords}}</span>
                                <span v-if="item.platform === '微博'">是否原发：{{originList[item.newsIsOrigin]}}</span>
                            </p>
                        </div> 
                    </li>
                </ul>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <!-- 下载选项 -->
        <Dialog ref="downloadOption" title="下载字段自定义选择" btnText="下载" :callback="enterOption" type="normal" width="600">
            <div slot="mdBox">
                <h4 v-if="downloadTips != ''">tips:<span class="color-red">{{downloadTips}}</span></h4>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="selectOptionValue.length === $parent.selectOption.length ? 'curr' : ''"><input name="" :checked="selectOptionValue.length === selectOption.length ? true : false" type="checkbox" @click="optionCheckAll($event);" value="" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">全选<span class="color-red">（为保证您的下载速度，请尽可能筛选必要的下载字段）</span></div>
                    </label>
                </div>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box" v-for="(item,index) in selectOption" :key="index">
                        <label class="checkbox-warp fl" :class="selectOptionValue.indexOf(item.type) != -1 ? 'curr' : ''"><input name="" v-model="selectOptionValue" type="checkbox" :value="item.type" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">{{item.name}}</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 情感属性纠错 -->
        <Dialog ref="errorCorrectionModal" title="情感属性纠错" :callback="enterErrorCorrection" btnText="确定" type="normal" width="300">
            <div slot="mdBox">
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="errorAttribute === '正面' ? 'curr' : ''"><input name="attribute" v-model="errorAttribute" type="radio" value="正面" class="radio"> <i class="icons radio-icon"></i></label>
                        <div class="hidden ac">正面</div>
                    </label>
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="errorAttribute === '中性' ? 'curr' : ''"><input name="attribute" v-model="errorAttribute" type="radio" value="中性" class="radio"> <i class="icons radio-icon"></i></label>
                        <div class="hidden ac">中性</div>
                    </label>
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="errorAttribute === '负面' ? 'curr' : ''"><input name="attribute" v-model="errorAttribute" type="radio" value="负面" class="radio"> <i class="icons radio-icon"></i></label>
                        <div class="hidden ac">负面</div>
                    </label>
                </div>
            </div>
        </Dialog>
		<!-- 保存筛选条件 -->
		<Dialog ref="saveConditions" :callback="saveScreeningConditions" btnText="保存" type="normal" title="创建筛选方案">
			<div slot="mdBox">
				<div class="form-warp">
					<div class="item">
						<input maxlength="5" v-model.trim="conditionName" type="text" placeholder="请输入筛选方案名称,最多5个字" class="input-text">
					</div>
				</div>
			</div>
		</Dialog>
        <!-- 一键复制 -->
		<copy ref="copy" :text="copyHtml"></copy>
        <!-- 溯源 -->
        <tracingTheSource :postData="postData"></tracingTheSource>
	</div>
</template>
<script>
import tracingTheSource from './components/tracingTheSource.vue'
import Dialog from '../../components/dialog.vue'
import VueDatepickerLocal from 'vue-datepicker-local'
import platTypeCascader from '../../components/platTypeCascader.vue';
import city from '../../components/city.vue';
import page from '../../components/page.vue';
import copy from '../../components/copy.vue';
import { mapState } from 'vuex';
export default {
    components:{VueDatepickerLocal,city,page,Dialog,copy,tracingTheSource,platTypeCascader},
    computed:{
        ...mapState({
            yujinType: state => state.show.yujinType,
            mediaLevelList: state => state.show.companyinfo.mediaLevelList
        })
    },
    data() {
        const min = ''
        const max = ''
        return {
            copyHtml:'',//复制的html
            attributeType:{
                '正面':'tag-blue',
                '中性':'tag-orange',
                '负面':'tag-red',
            },//属性对应的class样式
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
            openHide:false,//控制条件隐藏显示
			conditionsIndex:'',
			conditions:[],//筛选条件方案列表
			conditionName:'',//单次保存的筛选条件名称
            timeRange: [min, max],//时间
			selectOption:[],
            selectOptionValue:[],//已选择下载
            mediaList:['全部','政府','媒体','个人','其他'],//媒体字段
            emotionList:['全部','正面','中性','负面'],//情感字段
			mateList:['精准','模糊'],
			searchMode:1,//已选匹配模式
            pipei:['全文匹配','标题匹配'],//匹配字段
            repeatList:['不去重','去重'],//相似文章
            collapse:0,//去重type 0是不去重 1是去重
            xinYuanList:['全部','重点关注'],//信源选项列表
			source:0,//信源值
            paixu:{
                timeAsc:"时间升序",
                timeDesc:"时间降序",
                sortDesc:'权重排序'
            },//排序字段 
            searchPlaceholder:['请输入媒体发布人查询','请输入信息内容查询','请输入信息标题查询'],//搜索提示语
            MediaPlatformList:[],//媒体类型数组
            // 是否原发
            originList:['全部','是','否'],
            origin:0,//原发选择的值
            page:1,//页码
            limit:20,//每页显示条数
            totalCount:'',//总页数
            pageUuid:[],//单分页所有的uuid
            uuids:[],//选择的newsid数组
            planId:'',//方案ID
            mediaLevel:'',//媒体分类
            platformType:['total'],//媒体类型
            startDate:'',//开始时间
            endDate:'',//结束时间
            timeType:0,//时间乐类型
            searchText:['全部','标题','内容','发布人'],
            searchPlaceholder:['信息标题/内容/发布人查询','请输入信息标题查询','请输入信息内容查询','请输入媒体发布人查询'],//搜索提示语
            searchSelectVal:0,//搜素是的分类
            pubArea:'全国',
            emotion:['全部'],//情感属性
            match:'1',//匹配方式 1是全文匹配 2是标题匹配
            sort:'timeDesc',//排序类型 desc是降序 asc是升序
            keywords:'',//媒体关键词
            newsList:[],//新闻列表
            watch:true,//是否监听
            downLoadType:'',//下载类型
            nodata:false,//暂无数据
            noUpdateNum:0,//未更新条数
            timer:'',//请求定时器
            errorAttribute:'',//纠错属性的值
            errorCorrectionNewsId:'',//纠错的newsId
            downloadTips:'',
            morenzhi:{},
            postData:{}//文章追溯数据
            // switchRequest:false//防止多次请求
        }
    },
    mounted() {
        let that = this;
		that.$nextTick(() =>{
            let dayType = this.$route.query.dayType;
            let platformType = this.$route.query.platformType;
            let emotion = this.$route.query.emotion;
            let pubArea = this.$route.query.pubArea;
            
            if(this.$route.query.startDate != undefined && this.$route.query.startDate != ''){
                that.startDate = this.$route.query.startDate;
                that.endDate = this.$route.query.endDate;
            }
            if(dayType != undefined && dayType != ''){
                this.queryFrist = true;
                this.timeType = parseInt(dayType);
            }
            if(platformType != '' && platformType != undefined){
                this.queryFrist = true;
                this.platformType = [platformType];
            }
            if(pubArea != '' && pubArea != undefined){
                this.pubArea = pubArea;
                this.$refs.cityWarp.simpleName = pubArea;
            }
            if(emotion != '' && emotion != undefined){
                this.queryFrist = true;
                this.emotion = [emotion];
            }
            that.getConditions();
            //that.getNewsList(0);
        })
        //this.limit=sessionStorage.getItem('limitNum')?Number(sessionStorage.getItem('limitNum')):20;
    },
    beforeDestroy() {
        clearInterval(this.timeer);
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        //获取选中的方案
        getPlanvalue(e){
            this.mediaLevel = e;
            this.morenzhi = e;
            this.getNewsList(0);
        },
        // 获取当前时间和7天前时间
        initialTime(day) {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,day);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1]-1, o[2], n2[0], n2[1], n2[2])
            
            //进页面获取时间数据
            if(this.$route.query.startDate != undefined && this.$route.query.startDate != ''){
                this.startDate = this.$route.query.startDate;
                this.endDate = this.$route.query.endDate;
                this.timeRange = [this.startDate,this.endDate];
            }else{
                this.timeRange = [min,max];
                this.startDate = this.$utils.dateConversion(min,1);
                this.endDate = this.$utils.dateConversion(max,1);
            }
        },
        //选择时间回调
        selectedDate () {
            let that = this;
            that.watch = false;
            that.startDate = this.$utils.dateConversion(this.timeRange[0],1);
            that.endDate = this.$utils.dateConversion(this.timeRange[1],1);
            let day = that.$utils.getDateDiff(that.startDate,that.endDate);
            if(day > that.$parent.timeSection){
                that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天','',1500);
                return;
            }
            that.getMediaPlatform();
            that.getNewsList(0);
        },
        disabledDate(time){
            let day = this.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if(time.getTime() > new Date().getTime() || time.getTime() < number) return true;
        },
		// 匹配模式选择
		searchModeSelect (index) {
		    this.searchMode = index;
		    this.getMediaPlatform();
		    this.getNewsList(0);
		},
        // 固定时间选择
        selectFixedTime (type) {//0是今天 1是昨天 2是近三天 3是近7天 4是自定义
            let that = this;
			that.dynamicTime(type);
            that.getMediaPlatform();
            that.getNewsList(0);
        },
        // 动态获取时间
		dynamicTime (type){
			let that = this;
			let nowTime = this.$utils.getNowDate();//今天时间
			let n = nowTime.split(' ')[1].split(':');//拆分当前时分秒
			let h = n[0]; 
			let m = n[1]; 
			let s = n[2]; 
			let min = '';
			let max = '';
			that.timeType = type;
			if(type != 4){//非自定义
			    if(type === 0){
			        min = nowTime.split(' ')[0] + ' ' + '00:00:00';
			        max = nowTime;
			    }else if(type === 1){
			        let yesterday = this.$utils.getBeforeDay(nowTime,1);//前一天
			        min = yesterday + ' ' + '00:00:00';
			        max = yesterday + ' ' + '23:59:59';
			    }else if(type === 2){
			        let ptd = this.$utils.getBeforeDay(nowTime,3);//前三天
			        min = ptd + ' ' + h + ':' + m + ':' + s;
			        max = nowTime;
			    }else if(type === 3){
			        let psd = this.$utils.getBeforeDay(nowTime,7);//前七天
			        min = psd + ' ' + h + ':' + m + ':' + s;
			        max = nowTime;
			    }else if(type === 5){
			        let psd = this.$utils.getBeforeDay(nowTime,1);//24小时
			        min = psd + ' ' + h + ':' + m + ':' + s;
			        max = nowTime;
			    }else if(type === 6){
			        let day = JSON.parse(sessionStorage.getItem('planStorage')).adjustDay;
			        that.initialTime(day);
					return;
			    }
			    //进页面获取时间数据
			    that.startDate = min
			    that.endDate = max;
			}else{
			    let day = JSON.parse(sessionStorage.getItem('planStorage')).day;
			    that.initialTime(day);	
			}
		},
        // 选择搜索分类
        searchSelect (value) {
            this.searchSelectVal = value;
        },
        // 相似文章去重选择
        selectRepeat (index) {
            this.collapse = index;
            this.getMediaPlatform();
            this.getNewsList(0);
        },
        // 信源筛选
        xinYuanSelect (index){
            this.source = index;
            this.getMediaPlatform();
            this.getNewsList(0);
        },
        // 是否原发
        selectOriginlist (index){
            this.origin = index;
            this.getMediaPlatform();
            this.getNewsList(0);
        },
        //选择城市回调
        citySelect (name) {
            let that = this;
            that.watch = false;
            that.pubArea = name;
            that.getMediaPlatform();
            that.getNewsList(0);
        },
		// 获取筛选方案
		getConditions (){
			let that = this;
			that.$api.get('monitor/info/user-condition',{sid:that.planId},r =>{
				that.$utils.returnCode(r,function(){
                    that.conditions = r.data;
                    if(that.conditions.conditionId !== 0){//判断用户已经存在上次选择的筛选方案条件
                        if(JSON.stringify(that.$route.query) !== '{}'){//判断是否从其他页面跳转过来
                            that.selectFixedTime(that.timeType);
                            console.log(1)
                        }else{
                            let index = that.conditions.list.findIndex(item => item.conditionId === that.conditions.conditionId);
                            that.selectCondition(index,that.conditions.conditionId);
                            console.log(2)
                        }
                    }else{
                        that.selectFixedTime(that.timeType);
                        console.log(3)
                    }
				});
			})
		},
		// 删除筛选方案
		delConditions (id,index){
			let that = this;
			that.$confirm('是否删除筛选方案？').then(() => {
				let data = {
					conditionId:id
				}
				that.$parent.loadModal(true,'正在删除...');
				that.$api.post('monitor/info/save-user-condition',{data:data},r =>{
					that.$parent.showLoad = false;
					that.$utils.returnCode(r,function(){
						that.$utils.alertText('删除成功');
						that.conditions.list.splice(index,1);
					});
				})
			})
		},
		// 重置筛选条件
		resetConditions (){
			this.mediaLevel = "";
			this.emotion = ['全部'];
			this.searchMode = 1;
			this.source = 0,
			this.pubArea = '全国',
			this.match = 1;
			this.sort = 'timeDesc';
			this.collapse = 0;
			this.searchSelectVal = 0;
			this.keywords = '';
			this.timeType = 0;
			this.platformType = ['total'];
            this.mediaLevelList = [];
            this.morenzhi = [];
            this.origin = 0;
			this.$refs.cityWarp.simpleName = '';//简称显示

			this.selectFixedTime(0);
		},
		// 选择筛选条件方案
		selectCondition (index,id){
            let that = this;
			that.conditionsIndex = index;
            let condition = that.conditions.list[index];
            that.collapse = condition.condition.collapse;
			that.searchMode = condition.condition.searchMode;
			that.mediaLevel = condition.condition.mediaLevel;
            that.timeType = parseInt(condition.condition.timeType);
            that.morenzhi = condition.condition.mediaLevel=='全部'||condition.condition.mediaLevel==''?{}:condition.condition.mediaLevel;
            if(that.timeType === 4){//自定义
                let days = JSON.parse(sessionStorage.getItem('planStorage')).day;//当前最大时间范围权限
                let nowDate = that.$utils.dateToMillisecond(that.$utils.getNowDate());//当前时间戳
                let endMaxDate = that.$utils.dateToMillisecond(that.$utils.getBeforeDay(that.$utils.getNowDate(),days,1));
                if(that.$utils.dateToMillisecond(condition.condition.startDate) >= endMaxDate){
                    that.startDate = condition.condition.startDate;
				    that.endDate = condition.condition.endDate;
                }else{
                    // that.$utils.alertText('当前存储的自定义时间已过期');
                    that.$confirm('您所选择的自定义筛选方案时间已过期，已为您重置为近7天！您可以手动删除此筛选方案！').then(() => {})
                    that.startDate = that.$utils.returnTimeRange(1,7)[0];
                    that.endDate = that.$utils.returnTimeRange(1,7)[1];
                }
			}else{
				that.dynamicTime(that.timeType);
			}
            that.timeRange = [that.startDate,that.endDate];
            that.source = condition.condition.isFocus;
            that.origin = condition.condition.origin;
			// that.province = condition.condition.province;
			// that.showProvince = condition.condition.showProvince;
			that.$refs.cityWarp.simpleName = condition.condition.pubArea;//简称显示
            // that.city = condition.condition.city;
            that.pubArea = condition.condition.pubArea;
			that.emotion = condition.condition.emotion;
			that.match = condition.condition.match;
			that.sort = condition.condition.sort;
			that.searchSelectVal = condition.condition.searchType;
			that.keywords = condition.condition.keywords;
			that.platformType = condition.condition.platformType;
			that.getNewsList(0);
            that.getMediaPlatform();
            that.saveConditionSid(id);
        },
        // 存储信息汇总筛选方案
        saveConditionSid (id){
            let that = this;
            let data = {
                sid:that.planId,
                conditionId:id
            }
			that.$api.post('monitor/info/save-condition',{data:data},r =>{
				that.$parent.showLoad = false;
				that.$utils.returnCode(r,function(){});
			})
        },
		// 打开保存筛选弹框
		openSaveConditions (){
			if(this.conditions.list.length >= 3){
				this.$utils.alertText('最多只能保存3个筛选方案');
				return;
			}
			this.$refs.saveConditions.showMaskFun();
		},
		// 保存筛选方案
		saveScreeningConditions (){
			let that = this;
			let name = this.conditionName;
			if(name == ''){
				that.$utils.alertText('请输入筛选方案名称');
				return;
			}
			let data = {
				conditionId:'',
				conditionName:name,
				condition:{
					collapse:that.collapse,
					searchMode:that.searchMode,
					mediaLevel:that.mediaLevel,
                    platformType:that.platformType,
                    origin:that.origin,
					startDate:that.startDate,
					endDate:that.endDate,
					isFocus:that.source,
					pubArea:that.pubArea,
					emotion:that.emotion,
					match:that.match,
					sort:that.sort,
					timeType:that.timeType,
					searchType:that.searchSelectVal,
					keywords:that.keywords
				}
			}
			that.$parent.loadModal(true,'正在保存...');
			that.$api.post('monitor/info/save-user-condition',{data:data},r =>{
				that.$parent.showLoad = false;
				that.$utils.returnCode(r,function(){
                    that.$utils.alertText('保存成功');
					data.conditionId = r.data;
                    that.conditions.list.push(data);
					that.$refs.saveConditions.closeMask();
				});
			})
		},
        // 获取媒体类型
        getMediaPlatform () {
            let that = this;
        },
        // getMediaPlatform () {
        //     let that = this;
        //     // that.platformType = [];
        //     let data = {
        //         sid:that.planId,
        //         collapse:that.collapse,
		// 		searchMode:that.searchMode,
        //         mediaLevel:that.mediaLevel,
        //         origin:that.origin,
        //         startDate:that.startDate,
        //         endDate:that.endDate,
        //         isFocus:that.source,
        //         pubArea:that.pubArea,
		// 		match:that.match,
        //         emotion:that.emotion,
		// 		searchType:that.searchSelectVal,
		// 		keywords:that.keywords
        //     };
        //     that.$api.post('monitor/info/media-platform', {data:data}, r => {
        //         that.$utils.returnCode(r,function(){
        //             that.MediaPlatformList = r.data;
        //             that.watch = false;
        //         });
        //     })
        // },
        // enter键搜索
        KeyUpEsc () {
            this.getNewsList(0);
			this.getMediaPlatform();
        },
        // 获取新闻列表
        getNewsList (type) {
            let that = this;
            if(that.$parent.showLoad == true){
                return;
            }
            clearInterval(that.timer);//重置定时器
            that.noUpdateNum = 0;
            // that.switchRequest = true;
            if(type === 0){//非翻页
                that.page = 1;
            }
            let datas = {
                sid:that.planId,
                collapse:that.collapse,
                page:that.page,
				searchMode:that.searchMode,
                mediaLevel:that.mediaLevel,
                origin:that.origin,
                platformType:that.platformType,
                startDate:that.startDate,
                perpage:that.limit,
                endDate:that.endDate,
                isFocus:that.source,
                pubArea:that.pubArea,
                emotion:that.emotion,
                match:that.match,
                sort:that.sort,
                searchType:that.searchSelectVal,
                keywords:that.keywords
            };
            that.uuids = [];
            $(".warp .checkbox-warp").removeClass('curr');
            $(".warp input:checkbox[name='selectAll']").prop("checked",false);
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('monitor/info/list', {data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    // that.keywords = '';
                    that.newsList = data.list;//新闻列表赋值 
                    that.totalCount = data.total;
                    that.MediaPlatformList = data.platformDist;
                    let pageUuid = [];
                    let simHash = [];
                    let newsId = [];
                    for(let i of data.list){
                        pageUuid.push(i.newsId);
                    }
                    that.pageUuid = pageUuid;
                    if(data.list.length <= 0){//没有数据
                        that.nodata = true;
                        return;
                    }else{
                         that.nodata = false;
                    }
                    // 调用获取关键词和相似文章
                    that.getSimilarArticle(data.list);
                    if(that.timeType != 1 && that.timeType != 4){//昨天和自定义不计未读书
                        that.getNotUpdated();
                    }
                    // that.switchRequest = false;
                });
            })
        },
        // 获取最新未加载的消息
        getNotUpdated () {
            let that = this;
            let datas = {
                sid:that.planId,
                page:that.page,
				searchMode:that.searchMode,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                origin:that.origin,
                startDate:that.startDate,
                perpage:that.limit,
                endDate:that.endDate,
                pubArea:that.pubArea,
                emotion:that.emotion,
                match:that.match,
                sort:that.sort,
                searchType:that.searchSelectVal,
                keywords:that.keywords
            };
            that.timer = setInterval(() => {
                that.$api.post('monitor/info/find-new', {data:datas}, r => {
                    that.$utils.returnCode(r,function(){
                        that.noUpdateNum = r.data;
                    })
                })
            }, 300000);
        },
        // 更新当前数据
        updateCurrentData () {
            let that = this;
            that.selectFixedTime(that.timeType);
            that.getMediaPlatform();
            that.noUpdateNum = 0;
        },
        // 获取关键词和相似文章
        getSimilarArticle (data) {
            let that = this;
            let oldData = data;
            let simHash = [];
            let newsIds = [];
            let postDate = [];
            for(let i of data){
                simHash.push(i.newsSimHash);
                newsIds.push(i.newsId);
                postDate.push(i.newsPostdate);
            }
			let datas = {
			    sid:that.planId,
			    collapse:that.collapse,
			    page:that.page,
			    searchMode:that.searchMode,
                mediaLevel:that.mediaLevel,
                origin:that.origin,
			    platformType:that.platformType,
			    startDate:that.startDate,
			    perpage:that.limit,
			    endDate:that.endDate,
			    pubArea:that.pubArea,
			    emotion:that.emotion,
			    match:that.match,
			    sort:that.sort,
			    searchType:that.searchSelectVal,
			    keywords:that.keywords
			};
            that.$api.post('monitor/info/news-simnum', {simHash:simHash,newsId:newsIds,sid:that.planId,data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.simNum = datas[j].simNum;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
            that.$api.post('monitor/info/news-keyword', {postDate:postDate,newsId:newsIds}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.keywords = datas[j].keywords;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
        },
        // 鼠标以上情感属性显示记录
		showMaskmove (index){
			// let that = this;
			// if(that.newsList[index].emotionRecords.length <= 0){//没有记录则不显示
			// 	return;
			// }
			// if(!that.recordShow){//移上
			// 	that.recordShow = true;
			// 	that.$nextTick(() =>{
			// 		that.operationIndex = index;
			// 		let top = event.currentTarget.getBoundingClientRect().top;//获取距离浏览器顶部距离
			// 		let left = event.currentTarget.getBoundingClientRect().left + 36;
			// 		let h = that.$refs.moveMask.offsetHeight;//获取记录弹框的高度
			// 		let wh = window.innerHeight;//页面高度
			// 		let chaju = wh - top;//计算屏幕减去距离顶部的距离
			// 		if(chaju > h){
			// 			that.recordStyle = 'top:'+top+'px;left:'+left+'px';
			// 		}else{
			// 			that.recordStyle = 'bottom:'+(chaju - 18)+'px;left:'+left+'px';
			// 		}
			// 	})
			// }else{//移走
			// 	that.recordShow = false;
			// }
		},
        // 下拉筛选
        dropDownSelect (type,name) {
            let that = this;
            that.watch = false;
            if(type == 0){//媒体类别
                if(name === '全部'){
                    that.mediaLevel = '';
                }else{
                    that.mediaLevel = name;
                }
            }else if(type === 1){//情感属性
                if(name === '全部'){
                    that.emotion = '';
                }else{
                    that.emotion = name;
                }
            }else if(type === 2){//匹配类型
                that.match = name;
            }else if(type === 3){//排序类型
                that.sort = name;
            }
            // if(type === 0 || type === 1){
            //     that.getMediaPlatform();
            // }
            that.getNewsList(0);
            that.getMediaPlatform();
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            that.uuids = [];
            let checked = e.target.checked;
            if(checked == true){
                that.uuids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.uuids = [];
            }
        },
        // 下载
        downLoad (type) {
            let that = this;
            that.downLoadType = type;
            that.selectOptionValue = ['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_province','news_posttime','media_province'];
            let uuid = [];//全部下载为空
            if(type === 1){//选择下载
                uuid = that.uuids;
                if(uuid.length <= 0){
                    that.$utils.alertText('请选择需要下载的新闻');
                    return;
                }
            }else{
                if(that.newsList.length <= 0){
                    that.$utils.alertText('暂无可下载数据');
                    return;
                }
            }
            let data = {
                type:type,
                sid:that.planId,
                data:{
                    uuid:uuid,
                    collapse:that.collapse,
                    searchMode:that.searchMode,
                    mediaLevel:that.mediaLevel,
                    platformType:that.platformType,
                    origin:that.origin,
                    startDate:that.startDate,
                    endDate:that.endDate,
                    field:that.selectOptionValue,
                    pubArea:that.pubArea,
                    searchType:that.searchSelectVal,
                    isFocus:that.source,
                    emotion:that.emotion,
                    match:that.match,
                    sort:that.sort,
                    keywords:that.keywords
                }
            };
            that.$parent.loadModal(true,'请稍后...');
			that.$utils.getDownloadBefore(data,function(r){
                that.downloadTips = r.msg;
				that.selectOption = r.data.fieldList;
				that.$refs.downloadOption.showMaskFun();
			},function(){
                that.$parent.showLoad = false;
            })
        },
        // 确定下载字段
        enterOption () {
            let that = this;
            if(that.selectOptionValue.length <= 0){
                that.$utils.alertText('请选择需要下载的字段');
                return;
            }
            let uuid = [];//全部下载为空
            let type = that.downLoadType;
            if(type === 1){//选择下载
                uuid = that.uuids;
            }
            let data = {
                uuid:uuid,
                collapse:that.collapse,
				searchMode:that.searchMode,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                origin:that.origin,
                startDate:that.startDate,
                endDate:that.endDate,
                field:that.selectOptionValue,
                pubArea:that.pubArea,
                searchType:that.searchSelectVal,
                isFocus:that.source,
                emotion:that.emotion,
                match:that.match,
                sort:that.sort,
                keywords:that.keywords
            };
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/info/download', {type:type,sid:that.planId,data:data}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.selectOptionValue = [];
                    that.$refs.downloadOption.closeMask();
                    that.$parent.alertTips('已添加到我的下载列表');
                });
            })
        },
        // 下载字段全选
        optionCheckAll (e) {
            let that = this;
            that.selectOptionValue = [];
            let checked = e.target.checked;
            if(checked == true){
                let selectOption = that.selectOption;
                for(let i of selectOption){
                    that.selectOptionValue.push(i.type);
                }
            }else{
                that.selectOptionValue = [];
            }
            
        },
        //确认下载
        // enterDownload () {
            
        // },
        // 翻页
        getTableData () {
            let that = this;
            that.getNewsList(1);
        },
        //收藏
        collectFn (index) {
            let that = this;
            let newsList = that.newsList;
            let sc = newsList[index].collectStatus;//获取收藏状态
            let url = sc === 0 ? 'user/index/collect' : 'user/index/cancel-collect';
            let uUid = newsList[index].newsId;
            let data = {
                type:1,
                typeId:[uUid]
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:data}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    sc = sc === 0 ? 1 : 0;
                    newsList[index].collectStatus = sc;
                    that.$utils.alertText('操作成功');
                });
                
            })
        },
        //删除
        deleteList(e){
            let that = this;
            let uuid = [];
            if(e=='all'){
                uuid = that.uuids;
            }else{
                uuid = [e];
            }
            if(uuid.length <= 0){
                that.$utils.alertText('请选择需要删除的文章');
                return;
            }
            that.$confirm('是否删除文章？').then(() => {
                that.$api.post('monitor/info/delete', {newsId:uuid}, r => {
                    that.$utils.returnCode(r,function(){
                        that.$utils.alertText('删除成功');
                        // that.getNewsList(0);
                        for(let item of uuid){
                            for(let i=0;i<that.newsList.length;i++){
                                if(item == that.newsList[i].newsId){
                                    that.newsList.splice(i,1);
                                }
                            }
                        }
                    });
                })
			})   
        },
        // 预警
        earlyWarning (type,id) {
            let that = this;
            let isSupportArtificialWarningSet = that.$parent.isSupportArtificialWarningSet;//检测预警功能
            if(isSupportArtificialWarningSet != 1){
                that.$parent.alertTips('对不起，你暂无使用预警功能的权限！');
                return;
            }
            let uuid = '';
            let url = '';
            if(id === undefined){//批量预警
                url = 'monitor/warning/artificial-create';
                uuid = that.uuids;
            }else{
                uuid = [id];
            }
            if(type === 0){//添加预警
                url = 'monitor/warning/artificial-create';
            }else if(type === 1){//取消预警
                url = 'monitor/warning/artificial-delete';
            }
            if(uuid.length <= 0){
                that.$utils.alertText('请选择需要预警的新闻');
                return;
            }
            let datas = {
                sid:that.planId,
                newsId:uuid
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    let newsList = that.newsList;
                    for(let i of uuid){
                        for(let j of newsList){
                            if(i === j.newsId){
                                if(type === 1){//取消
                                    j.warningStatus = 0;
                                }else{//预警
                                    j.warningStatus = 1;
                                }
                            }
                        }
                    }
                    that.$utils.alertText(that.yujinType);
                });
            })
        },
        // 纠错
        errorCorrection (newsId) {
            this.errorCorrectionNewsId  = newsId;
            this.$refs.errorCorrectionModal.showMaskFun();
        },
        // 确认纠错选择
        enterErrorCorrection () {
            let that = this;
            let newsId = that.errorCorrectionNewsId;
            if(that.errorAttribute === ""){
                that.$utils.alertText('请选择情感属性');
                return;
            }
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post('monitor/info/emotion-feedback', {newsId:newsId,emotion:that.errorAttribute}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.errorAttribute = '';
                    that.$utils.alertText('纠错已提交，谢谢您的反馈');
                    that.$refs.errorCorrectionModal.closeMask();
                });
            })
        },
		// 跳转相似文章页面
		jumpSimilar (id) {
			let that = this;
			let datas = {
				newsId:id,
				// collapse:that.collapse,
				searchMode:that.searchMode,
				mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                origin:that.origin,
				startDate:that.startDate,
				endDate:that.endDate,
				pubArea:that.pubArea,
				emotion:that.emotion,
				match:that.match,
				isFocus:that.source,
				sort:that.sort,
				searchType:that.searchSelectVal,
				keywords:that.keywords
			};
			let routeData = that.$router.resolve({
				path: "/analysis/similarArticles",
				query: datas,
			});
			 window.open(routeData.href, '_blank');
		},
		// 一键复制
		oneClickCopy (index){
			let that = this;
            let list = that.newsList[index];
            this.copyHtml = '';
            let copyFields = JSON.parse(sessionStorage.getItem('planStorage')).copyFields;
            for(let i in copyFields){
                if(list[i] === undefined){
                    this.copyHtml += copyFields[i]+':'+'暂无\n'
                }else{
                    this.copyHtml += copyFields[i]+':'+list[i]+'\n'
                }
            }
        },
        // 文章追溯
        newsPathlist (simHash){
            this.postData = {
                simHash:simHash,
                sid:this.planId
            }
        }
    },
    watch: {
        platformType(){
            let that = this;
            let len = that.platformType.length;
            if(that.platformType[0] === 'total' && len > 1){//选择非全部 
                that.platformType.splice(0,1);
            }else if(that.platformType[len-1] === 'total' && len > 1){
                that.platformType = ['total'];
            } 
            that.getNewsList(0);
        },
		emotion () {
		    let that = this;
		    let len = that.emotion.length;
		    if(that.emotion[0] === '全部' && len > 1){//选择非全部 
		        that.emotion.splice(0,1);
		    }else if(that.emotion[len-1] === '全部' && len > 1){
		        that.emotion = ['全部'];
		    }
			//that.getMediaPlatform();
		    that.getNewsList(0);
        },
        // 监听路由
        $route(){
            this.getConditions();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/informationSet.vue